import { AccessType } from '@types';
import { ApiEndpointHandler } from '@sonar-software/sonar-http';

import { getDataSecurityDataAccessSearch, GetDataSecurityDataAccessSearchResponse } from './getDataAccessSearch';

export const getDataSecurityDataAccessPermissionSources:
ApiEndpointHandler<void, GetDataSecurityDataAccessSearchResponse> =
	(_, options) => getDataSecurityDataAccessSearch({
		queryString: '',
		searchLimit: 2000,
		target: [ AccessType.PermissionSet, AccessType.Profile ]
	}, options);
